import React from 'react';
import { Field } from 'formik';
import { Checkbox as SemanticCheckbox, Form } from 'semantic-ui-react';
import cn from 'classnames';
import { object, string } from 'prop-types';
import styled from 'styled-components';
import { text } from '../../../styles';

const StyledCheckbox = styled(SemanticCheckbox)`
  padding: 0.3rem;
  label {
    font-size: ${text.large} !important;
  }
`;

// eslint-disable-next-line
const CheckboxComponent = ({ field, form, className, ...props }) => {
  const checkboxCSS = cn('dscheckbox', className);

  return <StyledCheckbox {...field} {...props} className={checkboxCSS} />;
};

CheckboxComponent.propTypes = {
  field: object,
  form: object,
  className: string
};

const Checkbox = props => (
  <Form.Field>
    <Field component={CheckboxComponent} {...props} />
  </Form.Field>
);

export default Checkbox;
